import { Box, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const SubTitleField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 500,
          color: "text.primary",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
export default SubTitleField;
